module.exports = __webpack_public_path__ + "static/img/per2.8c1ce9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per2.jpg
// module id = eHCS
// module chunks = 41